/* eslint-disable no-unused-vars */
import dateFns from 'date-fns';
import { formatDate } from '../utils/formatDate';

/**
 * Verifica se a quantidade total de visitas em um dia (agregadas de todos os
 * profissionais e todos os eventos) excede um limite ('amount').
 *
 * @param {Array<Object>} schedulingEvents - Array de objetos de agendamento.
 * @param {Object} padVisit - Informações para o tipo de visita.
 *
 * Cada objeto deve ter:
 * - periodsForVisit (Array<{start: string, end: string}>) - Visitas agendadas.
 * @returns {Array<string>} - Array de mensagens de erro para dias que excedem o limite de visitas.
 */
function check(schedulingEvents, padVisit) {
  // O número máximo de visitas permitidas por dia
  const { frequencyAmount: amount } = padVisit || {};

  if (typeof amount !== 'number' || amount <= 0) {
    return;
  }

  const detailedErrors = [];
  const summaryErrors = [];

  // ====================================
  // 1. AGREGAÇÃO: Contar visitas por dia
  // ====================================
  // A chave será a data normalizada (ex: '2025-11-07T00:00:00.000Z')
  const dailyCountMap = new Map();

  for (const event of schedulingEvents) {
    const { periodsForVisit } = event;

    for (const periodVisit of periodsForVisit) {
      // Normaliza a data para o início do dia (meia-noite), eliminando o tempo.
      const dateKey = dateFns.startOfDay(new Date(periodVisit.start)).toISOString();

      // Incrementa a contagem para o dia
      const currentCount = dailyCountMap.get(dateKey) || 0;
      dailyCountMap.set(dateKey, currentCount + 1);
    }
  }

  // ================================================
  // 2. VERIFICAÇÃO: Comparar a contagem com o limite
  // ================================================
  for (const [dateKeyISO, count] of dailyCountMap.entries()) {
    if (count > amount) {
      // Formata a data para exibição no erro
      const formattedDate = formatDate(dateKeyISO);

      const errorMessage = `O número de visitas (${count}) excede o limite permitido de ${amount} para o dia ${formattedDate}.`;

      const aggregateErrorsMsg = `Há dia(s) cujo limite permitido de visita(s) é execedido.`;
      if (!summaryErrors.find(err => err === aggregateErrorsMsg)) {
        summaryErrors.push(aggregateErrorsMsg);
      }

      detailedErrors.push(errorMessage);
    }
  }

  return { detailedErrors, summaryErrors };
}

export { check };
